<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-project-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.958 3.244l19.433 10.6a1 1 0 010 1.756L24.958 26.2a2 2 0 01-1.915 0L3.61 15.6a1 1 0 010-1.756l19.433-10.6a2 2 0 011.915 0zM5.791 21.884l.14.068L24 31.461l18.069-9.509a2 2 0 111.863 3.54l-18.99 9.994c-.038.02-.076.04-.115.057l-.102.043-.176.06-.077.02-.136.028-.171.022-.129.006-.107-.001-.188-.016-.11-.017-.145-.033-.137-.042-.143-.056-.146-.07-18.991-9.995a2 2 0 011.722-3.608zM4.069 34.492l18.99 9.995.147.07.143.056.137.042.145.033.11.017.188.016h.107l.129-.005.171-.022.136-.028.077-.02.176-.06.102-.043a2.04 2.04 0 00.115-.056l18.99-9.995a2 2 0 10-1.863-3.54L24 40.461 5.932 30.952l-.141-.068a2 2 0 00-1.722 3.608z"/></svg>
</template>
<script>

export default {
  name: 'IconProjectFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
